import { store } from "../store";
import { store as uiStore } from "../store/ui";
import { api } from "../api";
import { DownloadFile } from "../interface";
import { DOWNLOAD_STATUS, DOWNLOAD_STATUS_TEXT } from "../HelperSrc";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

function checkFinish(files: DownloadFile[]) {
    let isFinish = true;
    store.downloadingFiles.forEach((storeFile: DownloadFile) => {
        let newStatus = "PROCESSING";
        files.forEach((file: DownloadFile) => {
            if (file.filename == storeFile.filename && file.status == "FINISH") {
                newStatus = file.status;
            }
        });

        if (storeFile.status != newStatus) {
            storeFile.status = newStatus;
        }
        isFinish = isFinish && newStatus == "FINISH";
    });

    if (isFinish) {
        store.waitingDownload.forEach((waitingFile: DownloadFile) => {
            let status = "";
            files.forEach((file: DownloadFile) => {
                if (file.filename == waitingFile.filename) {
                    status = "FINISH";
                    store.setWaitingFileStatus(waitingFile, status);
                }
            });

            isFinish = isFinish && status == "FINISH";
        });

        store.setDownloadingFile([]);
        if (isFinish) {
            uiStore.setDownloadStatus(DOWNLOAD_STATUS.FINISH);
        }
    }
}

async function getDownloadStatus(workbook: string, status: DOWNLOAD_STATUS): Promise<void> {
    if (!api.workbookApi) {
        return;
    }

    await api.workbookApi.getDownloadStatus(store.db ? store.db : "", workbook, DOWNLOAD_STATUS_TEXT[status]).then((response) => {
        if (response instanceof Error || (response.message && response.message.error)) {
            if (response instanceof Error) {
                HelperSrc.writeLog("error", response);
            } else {
                store.doNotice(lang[response.message.error]);
            }
            return;
        } else {
            const responseData = response as unknown as { results?: DownloadFile[] };

            if (responseData.results) {
                if (uiStore.downloadStatus == DOWNLOAD_STATUS.PROCESSING) {
                    checkFinish(responseData.results);
                    return;
                } else if (uiStore.preparingDownload && uiStore.downloadStatus == DOWNLOAD_STATUS.FINISH) {
                    uiStore.setDownloadStatus(DOWNLOAD_STATUS.DOWNLOADABLE);
                    return;
                }

                checkFinish(responseData.results);
            }
        }

        store.doNotice(lang.updateUser, true);
    });
}

export { getDownloadStatus };
